// src/services/api/world.js
// Region data, actions, tab data, and well functions.

import { fetchWithCommonHeaders, API_URL } from './helpers';

// Fetch region data
export const fetchRegionData = async (token, pointId) => {
    const url = `${API_URL}v2/region`;

    const response = await fetchWithCommonHeaders(url, {
        method: "POST",
        token,
        body: { pointId },
    });

    if (!response.ok) {
        throw new Error("Network response was not ok " + response.statusText);
    }

    return response.json();
};

export const fetchAction = async (token, action) => {
    const url = `${API_URL}v2/action`;
    const response = await fetchWithCommonHeaders(url, {
        method: "POST",
        token,
        body: { action },
    });
    if (!response.ok) {
        let errorResult = "error";
        try {
            const data = await response.json();
            if (data && data.result) {
                errorResult = data.result;
            }
        } catch (e) {}
        const err = new Error(errorResult);
        err.response = response;
        err.result = errorResult;
        throw err;
    }
    return response.json();
};

// Fetch v3 tab data
export const fetchV3TabData = async (token, tab) => {
    const url = `${API_URL}v2/v3/tabdata?tab=${encodeURIComponent(tab)}`;

    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
        credentials: 'include',
    });

    // Mark when response headers arrived (before body download + JSON parse)
    try { performance.mark('perf:fetchHeaders'); } catch (_) {}

    if (!response.ok) {
        let errorResult = "error";
        try {
            const data = await response.json();
            if (data && data.error) {
                errorResult = data.error;
            }
        } catch (e) {}
        const err = new Error(errorResult);
        err.response = response;
        err.result = errorResult;
        throw err;
    }

    return response.json();
};

// Fetch items eligible for throwing into well
export const fetchWellEligibleItems = async (token) => {
    const url = `${API_URL}v2/v3/api/well/eligible-items`;
    const response = await fetchWithCommonHeaders(url, {
        method: 'GET',
        token: token
    });

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || `Failed to fetch eligible items: ${response.status}`);
    }

    return response.json();
};

// Throw items into the well
export const throwItemsIntoWell = async (token, data) => {
    const url = `${API_URL}v2/v3/api/well/throw`;
    const response = await fetchWithCommonHeaders(url, {
        method: 'POST',
        token: token,
        body: data
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to throw items: ${response.status} ${errorText}`);
    }

    return response.json();
};
